import Color from 'color';
import { lFColor0, orange } from 'pages/components/LFHeader/LFHeader.styled';
import styled from 'styled-components';

export const Container = styled.div`
  background: white;
  padding: 22px 24px 20px;
  pointer-events: auto;
  width: 95vw;
  max-width: 380px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  color: #495057;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  transition: all ease-out 250ms;
`;

export const Header = styled.div`
  font-size: 17px;
  font-weight: 700;
  color: #212529;
  letter-spacing: -0.01em;
  line-height: 1.3;
  padding-right: 28px;
`;

export const Entry = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
  padding: 6px 11px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  max-width: 100%;
  word-break: break-word;
`;

export const Label = styled.div`
  margin-top: 14px;
  font-size: 13.5px;
  line-height: 1.5;
  color: #6c757d;
`;

export const Note = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 14px;
  font-size: 12.5px;
  line-height: 1.45;
  color: ${Color('#b45309').darken(0.05).toString()};
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 10px 12px;
  width: 100%;
  box-sizing: border-box;

  strong {
    font-weight: 700;
    letter-spacing: 0.02em;
  }

  svg {
    flex-shrink: 0;
    font-size: 18px;
    margin-top: 1px;
    color: #d97706;
  }
`;

export const NoteBody = styled.div`
  min-width: 0;
`;

export const ButtonsCont = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const Button0 = styled.button<{ $green?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  padding: 10px 18px;
  background: ${({ $green }) => ($green ? '#16a34a' : lFColor0)};
  color: white;
  border-radius: 8px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: background 120ms ease;
  &:hover {
    background: ${({ $green }) => ($green ? '#15803d' : orange)};
  }
`;

export const Button1 = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1.5px solid #dee2e6;
  padding: 10px 16px;
  background: white;
  color: #495057;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background 120ms ease;
  &:hover {
    background: #f8f9fa;
  }
`;
